
import { defineComponent, ref } from 'vue'
import { useRoute } from 'vue-router'
import { axios } from '@/plugins/axios'
import { useStore } from '@/store/index'

import { mdiBookmarkPlus, mdiBookmarkMinus } from '@mdi/js'
import BaseSvgIcon from '@/components/BaseSvgIcon.vue'

export default defineComponent({
  props: {
    isBookmarked: {
      type: Boolean,
      'default': () => (false),
    },
  },
  components: { BaseSvgIcon },
  setup() {
    const store = useStore()
    const route = useRoute()
    const btnDisabled = ref(false)

    const bookmarkSwitch = () => {
      btnDisabled.value = true
      axios
        .post(`/video/bookmark/${route.params.video_id}`)
        .then(response => {
          store.commit('video/setVideoDetails', response.data.payload)
        })
        .finally(() => btnDisabled.value = false)
    }

    return {
      mdiBookmarkMinus,
      mdiBookmarkPlus,
      bookmarkSwitch,
      btnDisabled
    }
  },
})
